module.exports = __webpack_public_path__ + "static/media/3 01 Tulleord Intro.bf46d706.mp3";